import React from 'react';
import {Route} from 'react-router-dom';
import {connect} from 'react-redux';

import HomePage from '../home/home.screen.js';

const App = () => (
  <div>
    <Route path="/:hash?" component={ HomePage } />
  </div>
);
const mapState = () => {};
export default connect(mapState)(App);



// WEBPACK FOOTER //
// ./src/app/root/index.js